<template>
  <div>
    <div class="topgoods">
      <p class="goodnum">累计收入 : {{total_profit}} &nbsp;&nbsp;&nbsp;&nbsp;   当前可提现收入 : {{account_balance}} &nbsp;&nbsp;&nbsp;&nbsp;   当前冻结中收入 : {{account_frozen_balance}}</p>
      
    </div>
    <div class="record_line"></div>

    <el-table :data="tableData"
      style="width:100%"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor">

    
        
      <el-table-column prop="created_at"
        label="时间"></el-table-column>
     

      <el-table-column label='收入/支出类型' prop="extra"
        >
       
      </el-table-column>
      <el-table-column prop='amount_change' label='变动金额（已扣除费率）'></el-table-column>
   
    </el-table>
<!-- 
   @size-change="handleSizeChange" -->
    <el-col :span="24">
      <div class="pagination">
        
        <el-pagination background
          @current-change="pageChange"
          :current-page="page"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
import {shopAccountIncome} from '@/api/shopdetail'
export default {
  props:['shopId'],
  data () {
    return {
      total_profit: 0,
      account_balance:0,
      account_frozen_balance:0,
      page:1,
      total:0,
      tableData: [],
    }
  },
   mounted (){
     this.getshopIncomeData(this.shopId)
  }, 
  watch: {
      shopId(newValue){
        if(newValue){
          this.getshopIncomeData(this.shopId)
        }
      }
  },
  methods: {
    async getshopIncomeData(shopId){
       var url = "page="+this.page
       console.log(url)
      let res = await shopAccountIncome(shopId,url)
      this.total_profit = res.data.total.total_income
      this.account_balance  = res.data.total.account_balance
      this.account_frozen_balance = res.data.total.account_frozen_balance
      this.tableData = res.data.list.data
      this.total = res.data.list.total
    },
    tc () {
      return "text-align:center; color:#333333; font-size:12px;";
    },
    tccolor () {
      return "text-align:center;background-color:#f5f5f5; font-size:14px;";
    },

    isUseActivityChange (id, e) {
      //更新成功后重新获取商品
      // this.getshoptypeopenorclose(id, e);
      console.log('id:' + id + ',e:' + e)
    },
    searchGoods () {
      this.page = 1
      this.getshopIncomeData(this.shopId)
    },
      pageChange(page) {
      this.page = page;
       this.getshopIncomeData(this.shopId)
    },
  }
}
</script>

<style lang="scss" scoped>
.topgoods {
  height: 30px;
  .goodnum {
    float: left;
    width: 720px;
  }
  .goodsname {
    float: right;
    width: 200px;
    margin-top: -5px;
  }
}
.record_line {
  margin: 10px 0;
  height: 1px;
  background-color: #e6e6e6;
}
.doing {
  color: blue;
}

.success {
  color: green;
}
.failure {
  color: red;
}
.operate_info {
  float: left;
}
.status—desc {
  float: right;
}
.pagination {
  float: right;
  margin-top: 15px;
}
</style>